import { SpecialFees, CLIENT_TYPE } from '@upstart/harmony/lib/constants';
import {
  InStoreControlPanelSteps,
  OnlineControlPanelSteps,
} from '@upstart/harmony/lib/flow-utils';
import { isEmbeddedInCommandCenter } from './commandCenter';

export const modalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

export const modalOverlayBackgroundColor = isEmbeddedInCommandCenter()
  ? 'rgba(255, 255, 255, 0.7)'
  : 'rgba(0, 0, 0, 0.25)';

export const scrollableModalStyles = {
  overlay: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: modalOverlayBackgroundColor,
  },
  content: {
    top: 'unset',
    bottom: 'unset',
    left: 'unset',
    right: 'unset',
    maxWidth: '100vw',
    maxHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
};

export const NEW_ADD_ONS_ROW = [
  { dmsCode: '', description: '', price: 0, cost: 0, taxed: false },
];

export const ADDONS_MODAL_HEADERS = ['Description', 'Price', 'Cost', 'Taxed'];
export const ADDONS_MODAL_HEADERS_WITH_DMS_CODE = [
  'Description',
  'DMS Code',
  'Price',
  'Cost',
  'Taxed',
];

export const ADDONS_MODAL_HEADERS_WITH_DEALERTRACK_MATCH_CODE = [
  'Description',
  'DealerTrack Match',
  'Price',
  'Cost',
  'Taxed',
];

export const ADD_ONS_HEADER = 'Add Ons';
export const ADD_ONS_BOSAK_HEADER = 'Bosak Protection';
export const DEALER_FEES_HEADER = 'Dealer Fees *';
export const PROTECTION_PLANS_HEADER = 'Protection Plans';
export const ACCESSORIES_HEADER = 'Accessories';

export const STANDALONE_TRADEIN_BUTTON_CLASSNAME =
  'prodigy-standalone-tradein-button';
export const STANDALONE_PREAPPROVAL_BUTTON_CLASSNAME =
  'prodigy-standalone-preapproval-button';
export const STANDALONE_BROWSE_BUTTON_CLASSNAME =
  'prodigy-standalone-browse-button';
export const STANDALONE_BYO_BUTTON_CLASSNAME = 'prodigy-standalone-byo-button';
export const STANDALONE_BYO_BANNER_CLASSNAME = 'prodigy-standalone-byo-banner';
export const RESERVATION_KIA_BUTTON_CLASSNAME =
  'prodigy-kia-reservation-button';
export const RESERVATION_KIA_BANNER_CLASSNAME =
  'prodigy-kia-reservation-banner';
export const RESERVATION_SUBARU_BUTTON_CLASSNAME =
  'prodigy-subaru-reservation-button';
export const RESERVATION_SUBARU_BANNER_CLASSNAME =
  'prodigy-subaru-reservation-banner';

export const BRANDS = [
  'Acura',
  'Alfa Romeo',
  'Aston Martin',
  'Audi',
  'Bentley',
  'BMW',
  'Buick',
  'Cadillac',
  'Chevrolet',
  'Chrysler',
  'Dodge',
  'Ferrari',
  'FIAT',
  'Ford',
  'Freightliner',
  'Genesis',
  'GMC',
  'Honda',
  'Hyundai',
  'INFINITI',
  'Jaguar',
  'Jeep',
  'Kia',
  'Lamborghini',
  'Land Rover',
  'Lexus',
  'Lincoln',
  'Lotus',
  'Maserati',
  'MAZDA',
  'McLaren',
  'Mercedes-Benz',
  'MINI',
  'Mitsubishi',
  'Nissan',
  'Porsche',
  'Ram',
  'Rolls-Royce',
  'Scion',
  'smart',
  'Subaru',
  'Tesla',
  'Toyota',
  'VinFast',
  'Volkswagen',
  'Volvo',
];

export const AccessoryType = {
  STATIC: 'static',
};

export const protectionPlanSource = {
  STATIC: 'static',
  PEN: 'pen',
};

export const DEALER_FEATURES = {
  Desking: 'desking',
  SoftCreditPullsInstore: 'softcreditpull-instore',
  SoftCreditPullsInstoreCreditApp: 'softcreditpull-instore-creditapp',
  SoftCreditPullsOnline: 'softcreditpull-online',
  ATCTaxes: 'atctaxes',
  ATCFees: 'atcfees',
  DriverLicenseScan: 'dlscan',
  ThirdPartyLeadEnhancement: 'leadenhancement',
  Online: 'online',
  InStore: 'instore',
  GlobalPricing: 'globalpricing',
  TextDeal: 'textdeal',
  HotLeads: 'hotleads',
  ChromeData: 'chromedata',
  AIS: 'ais',
  VirtualShowroom: 'virtualshowroom',
  Deposit: 'deposit',
  ProtectionPlansOnline: 'protectionplans-online',
  ProtectionPlansInstore: 'protectionplans-instore',
  AgedUnits: 'agedunits',
  StickerDeal: 'stickerdeal',
  InsuranceApplications: 'insuranceapplications',
};

export const DEFAULT_DEALER_FEATURE_LIST = [
  DEALER_FEATURES.InStore,
  DEALER_FEATURES.Online,
  DEALER_FEATURES.ThirdPartyLeadEnhancement,
  DEALER_FEATURES.Desking,
  DEALER_FEATURES.DriverLicenseScan,
  DEALER_FEATURES.SoftCreditPullsInstore,
  DEALER_FEATURES.SoftCreditPullsOnline,
  DEALER_FEATURES.ATCTaxes,
  DEALER_FEATURES.GlobalPricing,
];

export const protectionPlanSteps = {
  REGISTRATION: 'registration',
  PRODUCTS: 'products',
  BUNDLES: 'bundles',
};
export const SPECIAL_FEES_NAMES = {
  [SpecialFees.FLORIDA_DOC_STAMP]: 'Florida Doc Stamp',
  [SpecialFees.CALIFORNIA_LICENSE]: 'California License Fee',
  [SpecialFees.OREGON_CORPORATE_ACTIVITY_TAX]: 'Oregon Corporate Activity Tax',
  [SpecialFees.OREGON_PRIVILEGE_TAX]: 'Oregon Privilege Tax',
  [SpecialFees.TEXAS_VEHICLE_INVENTORY_TAX]: 'Texas Vehicle Inventory Tax',
  [SpecialFees.TENNESSEE_BUSINESS_TAX]: 'Tennessee Business Tax',
  [SpecialFees.TEXAS_LENDERS_AND_MEMBERS_FEE]: 'Texas Lenders And Members Fee',
};

export const FIXED_FEE_TYPE = 'fixed';

// Convert money rate to APR
export const RATE_TO_APR = 24;
export const RATE_FACTOR = 1 / RATE_TO_APR;

export function getClientTypeName(clientType) {
  switch (clientType) {
    case CLIENT_TYPE.ONLINE:
      return 'Online';
    case CLIENT_TYPE.IN_STORE:
    default:
      return 'In-Store';
  }
}

export const testingTimeZone = 'UTC';
export const defaultPageTitle = 'Upstart Auto Retail Dashboard';
export const pencilPageTitle = 'Deal';

export const OnlineInsurancePages = [
  {
    id: OnlineControlPanelSteps.creditApplication.id,
    name: 'Credit Application',
  },
  {
    id: 'summary',
    name: 'Deal Summary',
  },
  {
    id: OnlineControlPanelSteps.paymentBuilder.id,
    name: 'Ownership Options',
  },
];

export const InstoreInsurancePages = [
  InStoreControlPanelSteps.CREDIT_APPLICATION,
  InStoreControlPanelSteps.FORM_LIBRARY,
  InStoreControlPanelSteps.CAR_PAYMENT_BUILDER,
];

export const OnlinePseudoSteps = {
  pickup: 'pickup',
  delivery: 'delivery',
};

export const fauxTradeId = 'faux-trade-in';

export const EXPIRED_SKIP_MFA_DATE = 'December 1, 2022';

export const MAX_POLLING_BACKOFF = 60_000; // 60 seconds

export function getWidgetButtonCssClass(key) {
  let cssClass;
  if (key === 'tradein') {
    cssClass = STANDALONE_TRADEIN_BUTTON_CLASSNAME;
  } else if (key === 'preapproval') {
    cssClass = STANDALONE_PREAPPROVAL_BUTTON_CLASSNAME;
  } else if (key === 'browse') {
    cssClass = STANDALONE_BROWSE_BUTTON_CLASSNAME;
  } else if (key === 'byo') {
    cssClass = STANDALONE_BYO_BUTTON_CLASSNAME;
  } else if (key === 'byoBanner') {
    cssClass = STANDALONE_BYO_BANNER_CLASSNAME;
  } else if (key === 'kiaButton') {
    cssClass = RESERVATION_KIA_BUTTON_CLASSNAME;
  } else if (key === 'kiaBanner') {
    cssClass = RESERVATION_KIA_BANNER_CLASSNAME;
  } else if (key === 'subaruReserveButton') {
    cssClass = RESERVATION_SUBARU_BUTTON_CLASSNAME;
  } else if (key === 'subaruReserveBanner') {
    cssClass = RESERVATION_SUBARU_BANNER_CLASSNAME;
  } else {
    throw new Error('Unhandled Standalone Button Type');
  }
  return cssClass;
}

export const DO_NOT_LOG_PROPERTIES = ['freight'];

export const widgetsScriptURL =
  'https://widgets.upstart.com/priceButtonGroupAgent.v1.0.js';

export const ddcWidgetsAdapterURL =
  'https://widgets.upstart.com/DDCAdapter.min.js';

export const ALLOW_TAXABLE_ADDONS_TOGGLE_STATES = [
  'DE',
  'MD',
  'MN',
  'OR',
  'TX',
  'VT',
  'VA',
  'OH',
];
